module.exports = __webpack_public_path__ + "static/media/mc_hrz_pos_black.e3547cea.svg";